import SubscriptionPlans from "@/components/Dashboard/SubscriptionPlan/SubscriptionPlans.vue";
import SubscriptionPlanDetails from "@/components/Dashboard/SubscriptionPlan/SubscriptionPlanDetails.vue";

const subscriptionPlanRoutes = [
    {
        path: "subscriptionPlans",
        component: SubscriptionPlans,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "SubscriptionPlans",
    },
    {
        path: "subscriptionPlan/:id",
        component: SubscriptionPlanDetails,
        meta: {
            required: true,
            roles: ["PanelUser"],
        },
        name: "SubscriptionPlanDetails",
    },
]

export default subscriptionPlanRoutes;